<template>
  <NormalHeaderLayout header="Disclaimer">
    <p>The data presented in DASH is collected from the APNIC Community Honeynet Project, which is sourced from both APNIC-operated and independently operated honeypots. The availability, completeness and accuracy of information displayed in DASH cannot be guaranteed by APNIC and should be used for informational purposes only.</p>
    <p>The data presented in DASH is not a complete or exhaustive measurement of malicious traffic on a network. By the nature of the honeynet’s operation, the data presented in DASH is limited to the traffic seen at honeypots, and is further limited to the traffic types the honeypots are configured to detect.</p>
    <p>
      For more information visit the
      <a
        href="https://www.apnic.net/community/security/skills-and-knowledge/#project"
        target="_blank"
      >APNIC Community Honeynet project</a>.
    </p>
    <p>The location data in these reports should not be considered an authoritative indication of the location in which a resource is currently in use. Location data on this site refers to the economy in which an organization is registered at the time they receive an Internet resource allocation or assignment.</p>
  </NormalHeaderLayout>
</template>

<script>
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';

export default {
  components: {
    NormalHeaderLayout
  }
};
</script>

<style lang="scss" scoped>
</style>
